export enum CardImageAspectRatio {
    'one-quarter' = 1 / 1,
    'half' = 820 / 600,
    'two-thirds' = 1100 / 700,
    'one-third' = 540 / 700,
    'full' = 1660 / 934,
    'wide' = 1520 / 943,
    'slim' = 400 / 600,
}

export const determineAspectRatioByCardSpan = (span: 'oneThird' | 'half' | 'twoThirds' | 'oneQuarter' | undefined | null): number => {
    switch (span) {
        case 'oneQuarter':
            return CardImageAspectRatio['one-quarter'];
        case 'oneThird':
            return CardImageAspectRatio['one-third'];
        case 'half':
            return CardImageAspectRatio.half;
        case 'twoThirds':
            return CardImageAspectRatio['two-thirds'];
        default:
            return CardImageAspectRatio.full;
    }
};
